
<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.detail-row {
  display: flex;
  padding: 0 20px;
}
.detail-row .item {
  display: flex;
  flex: 1;
  align-items: center;
}
.detail-row .item .tittle {
  width: 110px;
  text-align: left;
}
.detail-row .item .content {
  width: 500px;
  text-align: left;
}
.detail-row .pdf-container img {
  width: 40px;
  height: 40px;
}
.detail-row .item .pdf-container {
  width: auto;
  text-align: center;
}
</style>
<style >
.freelist .el-form-item__content {
  margin-left: 0 !important;
}
.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.freelist .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
.freelist .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.freelist .el-image {
  visibility: hidden;
}
.freelist .file1 .el-upload--picture-card {
  display: none;
}
.el-image-viewer__wrapper {
  z-index: 99999 !important;
}
</style>
<template>
  <div class="content freelist">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">公司名称：</div>
           <el-select v-model="page.tenantGuid" placeholder="请选择" filterable   class="ipt-sty" @change="tenantChange">
             <el-option 
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">结算月份：</div>
          <el-date-picker
            class="ipt-sty"
            v-model="page.payMonth"
            type="month"
            align="left"
            unlink-panels
            placeholder="请选择"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">发放凭证：</div>
          <el-select v-model="page.giveStatue" placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in giveStatueList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div style="padding: 20px 20px 0 0; text-align: right">
        <el-button size="medium" type="info" @click="search">搜索</el-button>
        <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
      </div>
    </div>

    <div class="button-area"></div>
    <div class="back-color-fff p16" style="padding-top: 0">
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="payNo" width="150" label="结算编号" header-align="center" align="left" fixed="left">
          <template slot-scope="scope">{{ scope.row.payNo || '-'}}</template>
        </el-table-column>

        <el-table-column prop="payNo" min-width="240" label="公司名称" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>

        <el-table-column prop="payMonth" width="100" label="结算月份" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.payMonth || '-'}}</template>
        </el-table-column>
        <el-table-column prop="payMoney" width="140" label="结算金额(元)" header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.payMoney | numDigit | numFmt }}</template>
        </el-table-column>

        <el-table-column prop="startEndTime" width="200" label="结算时间段" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.startEndTime }}</template>
        </el-table-column>

        <el-table-column prop="payFile" width="140" label="支付凭证" header-align="center" align="left">
          <template slot-scope="scope">
            <a
              v-if="scope.row.payFile != '[]' && scope.row.payFile != null"
              class="txt-color"
              style="text-decoration: underline"
              @click="preview(scope.row.payFile)"
              >已上传,点击查看</a
            >
            <a v-else>待上传</a>
          </template>
        </el-table-column>
        <el-table-column prop="giveFile" width="140" label="发放凭证" header-align="center" align="left">
          <template slot-scope="scope">
            <a
              v-if="scope.row.giveFile != '[]' && scope.row.giveFile != null"
              class="txt-color"
              style="text-decoration: underline"
              @click="preview(scope.row.giveFile)"
              >已上传,点击查看</a
            >
            <a v-else>待运营上传</a>
          </template>
        </el-table-column>
        <el-table-column prop="note" width="140" label="备注" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.note || '-'}}</template>
        </el-table-column>
        <el-table-column prop="updateTime" width="140" label="上传发放凭证时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="createTime" width="100" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column width="120" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="editContract(scope.row)" v-if="!scope.row.giveFile">上传发放凭证</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="50%">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">关联任务包 </span>
          <el-select v-model="taskGuid" multiple placeholder="请选择" class="fl" style="width: 400px" disabled>
            <el-option v-for="item in taskList" :key="item.guid" :label="item.taskTitle" :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">结算月份 </span>
          <el-date-picker
            class="fl"
            style="width: 400px"
            v-model="payMonth"
            type="month"
            placeholder="选择日期时间"
            value-format="yyyy-MM"
            disabled
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="结算时间段">
          <el-input class="fl" style="width: 400px" v-model="startEndTime" disabled> </el-input>
        </el-form-item>

        <el-form-item label="结算金额">
          <el-input
            class="fl"
            style="width: 400px"
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            placeholder="单位（元）"
            v-model="payMoney"
            disabled
          >
          </el-input>
        </el-form-item>
        <div class="file1">
          <div style="text-align: left; margin-left: 100px; margin-bottom: 20px">大写：{{ payMoney | smallToBig }}</div>
          <el-form-item label="支付凭证截图">
            <el-upload
              action="#"
              name="image"
              class="fl"
              list-type="picture-card"
              :headers="token"
              :limit="10"
              accept=".jpg,.png,.jpeg"
              :on-exceed="handleExceed"
              :file-list="filePdfAttachList"
              :on-remove="handlePdfRemove"
              :http-request="uploadPdf"
              :on-preview="handlePictureCardPreview"
              disabled
            >
              <!-- <i slot="default" class="el-icon-plus"></i> -->
            </el-upload>
          </el-form-item>
        </div>
        <el-form-item label="备注说明">
          <el-input
            class="fl"
            style="width: 400px"
            type="textarea"
            :rows="5"
            :maxlength="200"
            placeholder="最多可输入200个字"
            v-model="note"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item label="上传发放凭证">
          <el-upload
            action="#"
            name="image"
            class="fl"
            list-type="picture-card"
            :headers="token"
            :limit="10"
            accept=".jpg,.png,.jpeg"
            :on-exceed="handleExceed"
            :file-list="filePdfAttachListII"
            :on-remove="handlePdfRemoveII"
            :http-request="uploadPdfII"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <div style="color: #999; text-align: left; margin-left: 100px; margin-bottom: 20px">
          说明：上传发放业务员费用的相关凭证截图
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新增结算单'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>

    <!-- <el-image :src="srcList?srcList[0]:''" ref="preview" :preview-src-list="srcList"></el-image> -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="srcList"
    />
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  data() {
    return {
      giveStatueList: [
        { value: '0', label: '全部' },
        { value: '1', label: '已上传' },
        { value: '2', label: '未上传' },
      ],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        giveStatue: 0,
        payMonth: '',
        tenantGuid: '',
        serviceTenantGuid:localStorage.guid
      },
      taskGuid: [],
      srcList: [],
      fullscreenLoading: false,
      textTitle: '新增结算单',
      dialogVisible: false,
      dialogVisible1: false,
      startEndTime: '',
      payMonth: '',
      payMoney: '',
      note: '',
      payFile: '',

      guid: '',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',

      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      filePdfAttachList: [],
      filePdfAttachListII: [],
      tenantList: [],
      showViewer: false,
      taskList: [],
      taskGroup: [],
      currentCompanyGuid:'',
      serviceTenantGuid: '',
      serviceTenantName: '',
    };
  },
  created() {
    this.page.giveStatue = this.$route.query.giveStatue;
  
    this.getTenantList();
    this.getTaskList();
  },
  watch: {
    payMonth(newVal) {
      if (!newVal) return;
      var newVal = newVal + '-01';
      var self = this;
      self.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?date=` +
            newVal +
            '&tenantGuid=' +
            this.currentCompanyGuid
        )
        .then((resp) => {
          self.startEndTime = resp.data.data.replace(',', '至');
        });
    },
  },
  methods: {
    getTaskList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        payState: '未结算',
        isService: 'Y'
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data.records) {
            self.taskList = res.data.data.records.concat(this.taskGroup);
          } else {
            self.taskList = this.taskGroup;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    preview(srcList) {
      this.srcList = [];
      var srcList = JSON.parse(srcList);
      srcList.forEach((item) => {
        this.srcList.push(item.url);
      });
      this.$forceUpdate();
      this.showViewer = true;
      // setTimeout(()=>{
      //   this.$refs.preview.clickHandler()
      // },300)
    },
    getTenantList() {
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
          self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    search() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: 10,
        giveStatue: this.page.giveStatue,
        payMonth: this.page.payMonth,
        tenantGuid: this.page.tenantGuid,
        serviceTenantGuid:localStorage.guid
      };

      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/pay/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        giveStatue: '0',
        payMonth: '',
        tenantName: '',
        serviceTenantGuid:localStorage.guid
      };

      this.page.tenantGuid = this.tenantList[0].sendTenantGuid;
      this.getList();
    },
    addContract() {
      this.textTitle = '新增结算单';
      this.guid = '';
      this.payMonth = '';
      this.payMoney = '';
      this.startEndTime = '';
      this.note = '';
      this.filePdfAttachList = [];
      this.dialogVisible = true;
    },
    editContract(detail) {
      this.textTitle = '上传费用发放凭证';
      this.guid = detail.guid;
      this.startEndTime = detail.startEndTime;
      this.note = detail.note;
      this.payMoney = detail.payMoney;
      this.payMonth = detail.payMonth;
      this.serviceTenantGuid =detail.serviceTenantGuid;
      this.serviceTenantName =detail.serviceTenantName;
      this.dialogVisible = true;
      this.filePdfAttachList = [];
      this.filePdfAttachListII = [];
      if (detail.payFile) var payFile = JSON.parse(detail.payFile);
      this.currentCompanyGuid = detail.tenantGuid;
      payFile.forEach((item) => {
        this.filePdfAttachList.push({
          name: item.name,
          url: item.url,
        });
      });

      let taskGroup = JSON.parse(detail.taskGroup);
      this.taskGroup = taskGroup;
      this.taskGuid = [];
      if (taskGroup) {
        taskGroup.forEach((item) => {
          this.taskGuid.push(item.guid);
        });
      }
      this.$forceUpdate();
    },
    getList() {
      var self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/pay/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delContract(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/pay/delete?guid=${guid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.payMonth) {
        self.$message('请选择结算月份');
        return;
      }
      var payFile = JSON.stringify(this.filePdfAttachList);
      var tenantList = this.tenantList;
      var tenantObj = tenantList.find((item) => item.guid == localStorage.guid);
      var req = {
        tenantGuid: localStorage.guid,
        tenantName: tenantObj.tenantName,
        note: this.note,
        payMonth: this.payMonth,
        payMoney: this.payMoney,
        startEndTime: this.startEndTime,
        payFile: payFile,
        isRead: 'N',
      };

      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/pay/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      var giveFile = JSON.stringify(this.filePdfAttachListII);
      var filePdfAttachListII = this.filePdfAttachListII;
      if (filePdfAttachListII.length == 0) {
        self.$message.error('请上传上传发放凭证');
        return;
      }

      var req = {
        giveFile: giveFile,
        guid: this.guid,
        isRead: 'N',
      };

      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/pay/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('上传费用发放凭证成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },

    handleExceed(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 10 个文件`);
    },
    handlePdfRemove(file) {
      let self = this;
      self.filePdfAttachList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.filePdfAttachList.splice(ind, 1);
        }
      });
    },
    uploadPdf(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '费用结算单',
              url: res.data.data,
            };
            self.filePdfAttachList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handlePdfRemoveII(file) {
      let self = this;
      self.filePdfAttachListII.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.filePdfAttachListII.splice(ind, 1);
        }
      });
    },
    uploadPdfII(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: '发放凭证',
              url: res.data.data,
            };
            self.filePdfAttachListII.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handlePictureCardPreview(item) {
      this.srcList = [];
      this.srcList.push(item.url);
      this.$forceUpdate();
      setTimeout(() => {
        this.$refs.preview.clickHandler();
      }, 300);
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>